
export default {
    props: {
        show: Boolean,
    },
}
